import React from 'react';
import { 
  IoCloseOutline, 
  IoChevronForwardOutline,
  IoChevronBackOutline
} from 'react-icons/io5';

const Icon = ({ name, size = 24, color = 'currentColor', className = '' }) => {
  const icons = {
    close: IoCloseOutline,
    chevronRight: IoChevronForwardOutline,
    chevronLeft: IoChevronBackOutline,
  };

  const IconComponent = icons[name];

  if (!IconComponent) {
    console.warn(`Ícone "${name}" não encontrado`);
    return null;
  }

  return <IconComponent size={size} color={color} className={className} />;
};

export default Icon;